import apiClient from '../apiClient';
import API_CONFIG from '../config';

const TOKEN_KEY = 'auth_token';

/**
 * Service for handling authentication operations
 */
const authService = {
  /**
   * Login with email and password
   * @param {string} email - User's email
   * @param {string} password - User's password
   * @returns {Promise} - Authentication response
   */
  login: async (email, password) => {
    console.log('AuthService: Attempting login with:', email);
    // In a real app, this would make an API call to your backend
    // For demo purposes, we'll simulate a successful login
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (email && password) {
          const token = 'mock_jwt_token';
          localStorage.setItem(TOKEN_KEY, token);
          console.log('AuthService: Login successful, token set:', token);
          resolve({ token });
        } else {
          console.log('AuthService: Login failed: Invalid credentials');
          reject(new Error('Invalid credentials'));
        }
      }, 1000);
    });
  },

  /**
   * Logout the current user
   */
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
  },

  /**
   * Check if user is authenticated
   * @returns {boolean} - Authentication status
   */
  isAuthenticated: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    console.log('AuthService: Checking authentication status:', !!token);
    return !!token;
  },

  /**
   * Get the current authentication token
   * @returns {string|null} - Authentication token
   */
  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Register a new patient
   * @param {Object} patientData - Patient registration data
   * @returns {Promise} - Registration response
   */
  register: async (userData) => {
    // In a real app, this would make an API call to your backend
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (userData.email && userData.password) {
          resolve({ success: true });
        } else {
          reject(new Error('Invalid registration data'));
        }
      }, 1000);
    });
  },

  /**
   * Social login
   * @param {string} provider - Social provider (google, facebook, apple, microsoft)
   * @returns {Promise} - Authentication response
   */
  socialLogin: async (provider) => {
    // In a real app, this would integrate with the social provider's OAuth flow
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const validProviders = ['google', 'facebook', 'apple', 'microsoft'];
        if (validProviders.includes(provider)) {
          const token = `mock_${provider}_token`;
          localStorage.setItem(TOKEN_KEY, token);
          resolve({ token });
        } else {
          reject(new Error(`Unsupported provider: ${provider}`));
        }
      }, 1000);
    });
  },

  /**
   * Reset password request
   * @param {string} email - User's email
   * @returns {Promise} - Reset password response
   */
  requestPasswordReset: async (email) => {
    // In a real app, this would make an API call to your backend
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true });
      }, 1000);
    });
  },

  /**
   * Reset password with token
   * @param {string} token - Reset token
   * @param {string} newPassword - New password
   * @returns {Promise} - Reset password response
   */
  resetPassword: async (token, newPassword) => {
    // In a real app, this would make an API call to your backend
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true });
      }, 1000);
    });
  },
};

export { authService }; 